import { isNull } from 'lodash';

import { moment } from '../../I18n';
import { PostTypes, PostStatuses } from '../Types';
import PostPhaseStatuses from '../Types/PostPhaseStatuses';
import PostVisibilities from '../Types/PostVisibilities';

export const postIsClosedForParticipation = (post: any) => {
  return !isNull(post.end_at) && moment(post.end_at).isBefore(moment());
};

export const postParticipationStarted = (post: any) => {
  const postHasStarted = !post.start_at || moment(post.start_at).isBefore(moment());

  return postHasStarted;
};

export const isPostComing = (post: any) =>
  !postParticipationStarted(post) && !postIsClosedForParticipation(post);
export const isPostOngoing = (post: any) =>
  postParticipationStarted(post) && !postIsClosedForParticipation(post);
export const isPostEnded = (post: any) => postIsClosedForParticipation(post);

export const postHasParent = (post: any) => !!post?.post_record_id || !!post.included?.source?.id;

export const isCollaborativeDecision = (postType: any) =>
  postType === PostTypes.COLLABORATIVE_DECISION;
export const isIdea = (postType: any) => postType === PostTypes.IDEA;
export const isIdeasRequest = (postType: any) => postType === PostTypes.IDEAS_REQUEST;
export const isAnomaly = (postType: any) => postType === PostTypes.ANOMALY;
export const isMessage = (postType: any) => postType === PostTypes.DEMAND;
export const isParticipatoryBudget = (postType: any) => postType === PostTypes.PARTICIPATORY_BUDGET;
export const isFolder = (postType: any) => postType === PostTypes.FOLDER;
export const isStudy = (postType: any) => postType === PostTypes.STUDY;
export const isEvent = (postType: any) => postType === PostTypes.EVENT;
export const isArticle = (postType: any) => postType === PostTypes.ARTICLE;

export const isParentPost = (postType: any) =>
  isCollaborativeDecision(postType) ||
  isIdeasRequest(postType) ||
  isFolder(postType) ||
  isParticipatoryBudget(postType);

// TODO: rename to post phase status or get it from api payload
export const getPostStatus = (post: any) => {
  if (moment(post.end_at).isBefore(moment())) {
    return PostPhaseStatuses.ENDED;
  }

  if (moment(post.start_at).isAfter(moment())) {
    return PostPhaseStatuses.COMING;
  }

  return PostPhaseStatuses.ONGOING;
};

export const isAnswered = (post: any) =>
  post.status === PostStatuses.ANSWERED || post.status === PostStatuses.VALIDATED;

export const phaseEnded = (phaseStatus: any) => phaseStatus === PostPhaseStatuses.ENDED;
export const phaseComing = (phaseStatus: any) => phaseStatus === PostPhaseStatuses.COMING;
export const phaseOngoing = (phaseStatus: any) => phaseStatus === PostPhaseStatuses.ONGOING;

export const isPostPublished = (post: any) => !!post?.published_at;

export const getPostVisibility = (post: any) => {
  if (!isPostPublished(post) && !post.ask_to_publish_at) return PostVisibilities.DRAFT;
  if (!isPostPublished(post) && post.ask_to_publish_at) return PostVisibilities.PLANNED;

  return isPostPublished(post) ? PostVisibilities.PUBLISHED : PostVisibilities.DRAFT;
};

export const getPostPublicationDate = (post: any) => {
  switch (getPostVisibility(post)) {
    case PostVisibilities.PUBLISHED:
      return post.published_at;
    case PostVisibilities.PLANNED:
      return post.ask_to_publish_at;
    default:
      return null;
  }
};
